import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { Globe2, Menu, X } from "lucide-react";
import { NAV_ITEMS } from "../mock/mockData";

export function SiteHeader({ 
  lang, 
  onLangChange, 
  onNavClick, 
  mobileOpen, 
  setMobileOpen,
  showNavigation = true 
}) {
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 border-b border-slate-300 bg-slate-50/95 backdrop-blur-xl h-[110px]">
      <div className="mx-auto flex h-full max-w-6xl items-center justify-between px-4 md:px-6">
        <div 
          className="flex items-center gap-3 cursor-pointer" 
          onClick={() => navigate("/")}
        >
          <img src={"/assets/!!!SLA_logo.png"} alt="SLA logo" className="h-9 w-auto" loading="eager" />
          <div className="hidden flex-col text-xs font-medium uppercase tracking-[0.18em] text-slate-700 sm:flex">
            <span>Strategic Lobbying Alliance</span>
          </div>
        </div>
        
        {showNavigation && (
          <nav className="hidden items-center gap-8 text-sm font-medium text-slate-600 md:flex">
            {NAV_ITEMS.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => onNavClick(item.anchor)}
                className="relative text-xs uppercase tracking-[0.18em] text-slate-500 transition-colors hover:text-amber-600"
              >
                {item.label[lang]}
              </button>
            ))}
          </nav>
        )}
        
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-1 rounded-full border border-slate-300 bg-slate-100 p-1 text-[11px] font-semibold uppercase tracking-[0.18em]">
            <button
              type="button"
              onClick={() => onLangChange("en")}
              className={`px-2 py-1 rounded-full transition-colors ${
                lang === "en" ? "bg-amber-500 text-slate-900" : "text-slate-600 hover:text-amber-600"
              }`}
            >
              EN
            </button>
            <button
              type="button"
              onClick={() => onLangChange("ua")}
              className={`px-2 py-1 rounded-full transition-colors ${
                lang === "ua" ? "bg-amber-500 text-slate-900" : "text-slate-600 hover:text-amber-600"
              }`}
            >
              UA
            </button>
          </div>
          {showNavigation && (
            <button
              type="button"
              className="flex h-9 w-9 items-center justify-center rounded-full border border-slate-300 bg-slate-50 text-slate-700 md:hidden"
              onClick={() => setMobileOpen((v) => !v)}
              aria-label="Toggle navigation"
            >
              {mobileOpen ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
            </button>
          )}
        </div>
      </div>
      {showNavigation && mobileOpen && (
        <div className="border-t border-slate-600 bg-[#041e41] px-4 pb-4 pt-2 md:hidden">
          <nav className="flex flex-col gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-slate-100">
            {NAV_ITEMS.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => onNavClick(item.anchor)}
                className="rounded-md px-2 py-2 text-left hover:bg-slate-700 hover:text-amber-400"
              >
                {item.label[lang]}
              </button>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
